const mapping: Record<
  string,
  (lambdaParameter: string, value: any, otherValues: any) => string | null
> = {
  ticketCode: (lambdaParameter, value) =>
    `${lambdaParameter}.TicketCode.Contains("${value}")`,
  bookingId: (lambdaParameter, value) => {
    if (value) {
      return `${lambdaParameter}.BookingId.Equals(${value})`
    }
    return `true`
  },
  customerId: (lambdaParameter, value) =>
    `${lambdaParameter}.Booking.CustomerId.Equals(${value})`,
  dateFrom: (lambdaParameter, value) => {
    if (typeof value === 'undefined') {
      return `true`
    }
    if (typeof value === 'string') {
      return `${lambdaParameter}.Date > DateTime.Parse("${value}")`
    }
    return `true`
  },
  dateTo: (lambdaParameter, value) => {
    if (typeof value === 'undefined') {
      return `true`
    }
    if (typeof value === 'string') {
      return `${lambdaParameter}.Date < DateTime.Parse("${value}")`
    }
    return `true`
  },
  lastDay: (lambdaParameter, value) => {
    if (value) {
      return `${lambdaParameter}.Date > DateTime.Now.AddDays(-1)`
    }
    return `true`
  },
  lastWeek: (lambdaParameter, value) => {
    if (value) {
      return `${lambdaParameter}.Date > DateTime.Now.AddDays(-7)`
    }
    return `true`
  },
  lastMonth: (lambdaParameter, value) => {
    if (value) {
      return `${lambdaParameter}.Date > DateTime.Now.AddMonths(-1)`
    }
    return `true`
  },
  deviceName: (lambdaParameter, value) =>
    `${lambdaParameter}.Device.Name.Contains("${value}")`,
  text: (lambdaParameter, value) =>
    `${lambdaParameter}.Data.Text.Contains("${value}")`,
  objectId: (lambdaParameter, value) => {
    if (value) {
      return `${lambdaParameter}.Booking.Event.Objects.Any(o=>o.Id.Equals(${value}))`
    }
    return `true`
  },
  eventId: (lambdaParameter, value) => {
    if (value) {
      return `${lambdaParameter}.Booking.Event.Id.Equals(${value})`
    }
    return `true`
  },
  deviceId: (lambdaParameter, value) => {
    if (value) {
      return `${lambdaParameter}.Device.Id.Equals(${value})`
    }
    return `true`
  },
  categoryIdWithDescendants: () => null,
  categoriesIds: (lambdaParameter, value) =>
    `new int%3F[] {${(
      value as number[]
    )?.toString()}}.Contains(${lambdaParameter}.Device.CategoryId)`,
  schemeIdWithDescendants: () => null,
  schemesIds: (lambdaParameter, value) =>
    `new int%3F[] {${(
      value as number[]
    )?.toString()}}.Contains(${lambdaParameter}.SchemeId)`,
  search: (lambdaParameter, value) =>
    `${value
      .toString()
      .split(' ')
      .map(
        (q: string) =>
          `(${lambdaParameter}.Id+" "+${lambdaParameter}.Text).Contains("${q}")`,
      )
      .join('&&')}`,
  simpleView: (lambdaParameter, value) =>
    `${lambdaParameter}.Scheme.LogSchemeData.Any(lsd => lsd.Language == "${value}" && !lsd.HiddenInSimpleView)`,
  variantId: (lambdaParameter, value) =>
    `${lambdaParameter}.Booking.VariantId.Equals(${value})`,
}

export const filterMapper = (key: string) =>
  mapping[key] as (
    lambdaParameter: string,
    value: any,
    otherValues: any,
  ) => string

export default filterMapper
